"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateManager = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const lucide_react_1 = require("lucide-react");
const useStore_1 = require("../../store/useStore");
require("./UpdateManager.css");
const APP_VERSION = '1.1.0'; // Mevcut Sürüm
const UpdateManager = () => {
    const isElectron = typeof window !== 'undefined' && !!window.require;
    if (!isElectron) {
        return null; // Web version is always live and never prompts for app updates
    }
    const { isVersionBlocked, setVersionBlocked } = (0, useStore_1.useStore)();
    const [latestVersion, setLatestVersion] = (0, react_1.useState)(null);
    const [downloadUrl, setDownloadUrl] = (0, react_1.useState)(null);
    const [releaseNotes, setReleaseNotes] = (0, react_1.useState)('');
    const [isMandatory, setIsMandatory] = (0, react_1.useState)(false);
    const [showBanner, setShowBanner] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const fetchLatestInfo = async () => {
            try {
                const channel = localStorage.getItem('meci_release_channel') || 'production';
                const getPlatform = () => {
                    const ua = window.navigator.userAgent.toLowerCase();
                    if (ua.includes('windows') || ua.includes('win32'))
                        return 'windows';
                    if (ua.includes('macintosh') || ua.includes('mac os x'))
                        return 'macos';
                    if (ua.includes('linux'))
                        return 'linux';
                    if (ua.includes('android'))
                        return 'android';
                    if (ua.includes('iphone') || ua.includes('ipad'))
                        return 'ios';
                    return 'windows';
                };
                const platform = getPlatform();
                const response = await fetch(`https://meci.teymensel.com/api/v1/versions/check?app_version=${APP_VERSION}&channel=${channel}&platform=${platform}`);
                if (response.ok) {
                    const data = await response.json();
                    setLatestVersion(data.latest_version);
                    setDownloadUrl(data.latest_download_url || data.min_required_download_url);
                    setReleaseNotes(data.latest_release_notes || 'Performans iyileştirmeleri ve hata düzeltmeleri.');
                    if (data.status === 'blocked') {
                        setIsMandatory(true);
                        setVersionBlocked(true); // Global state update
                    }
                    else if (data.latest_version && data.latest_version !== APP_VERSION) {
                        // Check if latest version is actually newer (basic string compare for simplicity)
                        if (data.latest_version.localeCompare(APP_VERSION, undefined, { numeric: true, sensitivity: 'base' }) > 0) {
                            setShowBanner(true);
                        }
                    }
                }
            }
            catch (e) {
                console.error('Sürüm bilgisi alınamadı:', e);
            }
            finally {
                setLoading(false);
            }
        };
        fetchLatestInfo();
        // Periyodik kontrol (her 1 saatte bir)
        const interval = setInterval(fetchLatestInfo, 3600000);
        return () => clearInterval(interval);
    }, [setVersionBlocked]);
    const handleDownload = () => {
        if (!downloadUrl) {
            window.open('https://meci.teymensel.com', '_blank');
            return;
        }
        const isAbsoluteUrl = downloadUrl.startsWith('http');
        const fullUrl = isAbsoluteUrl ? downloadUrl : `https://meci.teymensel.com${downloadUrl}`;
        // Electron ipcRenderer if available, else standard browser download
        if (typeof window !== 'undefined' && window.require) {
            const { shell } = window.require('electron');
            shell.openExternal(fullUrl);
        }
        else {
            window.open(fullUrl, '_blank');
        }
    };
    // 1. Zorunlu Güncelleme Ekranı (Tüm ekranı kilitler)
    if (isVersionBlocked || isMandatory) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "force-update-overlay", children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "force-update-card", initial: { opacity: 0, scale: 0.9, y: 20 }, animate: { opacity: 1, scale: 1, y: 0 }, transition: { duration: 0.3 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "update-icon-wrapper mandatory", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AlertTriangle, { size: 48, className: "warn-icon" }), (0, jsx_runtime_1.jsx)(lucide_react_1.RefreshCw, { size: 24, className: "sync-icon" })] }), (0, jsx_runtime_1.jsx)("h1", { className: "update-title", children: "Zorunlu G\u00FCncelleme" }), (0, jsx_runtime_1.jsxs)("p", { className: "update-desc", children: ["Kulland\u0131\u011F\u0131n\u0131z uygulama s\u00FCr\u00FCm\u00FC art\u0131k desteklenmemektedir. Devam etmek i\u00E7in l\u00FCtfen son s\u00FCr\u00FCme (", latestVersion, ") g\u00FCncelleyin."] }), !loading && ((0, jsx_runtime_1.jsxs)("div", { className: "version-info-box animate-fade-in", children: [(0, jsx_runtime_1.jsxs)("div", { className: "version-badge-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "info-label", children: "Mevcut S\u00FCr\u00FCm:" }), (0, jsx_runtime_1.jsxs)("span", { className: "version-badge old", children: ["v", APP_VERSION] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "version-badge-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "info-label", children: "Gerekli S\u00FCr\u00FCm:" }), (0, jsx_runtime_1.jsxs)("span", { className: "version-badge", children: ["v", latestVersion] })] })] })), (0, jsx_runtime_1.jsx)("div", { className: "update-actions", children: (0, jsx_runtime_1.jsxs)("button", { className: "btn btn-primary btn-large w-full", onClick: handleDownload, disabled: loading, children: [loading ? (0, jsx_runtime_1.jsx)(lucide_react_1.Loader2, { className: "animate-spin" }) : (0, jsx_runtime_1.jsx)(lucide_react_1.Download, { size: 20, className: "mr-2" }), loading ? 'Yükleniyor...' : 'Güncellemeyi İndir'] }) })] }) }));
    }
    // 2. İsteğe Bağlı Güncelleme Banner'ı (Üstte belirir)
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: showBanner && ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "update-banner", initial: { opacity: 0, y: -50 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: -50 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "update-banner-content", children: [(0, jsx_runtime_1.jsx)("div", { className: "update-banner-icon", children: (0, jsx_runtime_1.jsx)(lucide_react_1.RefreshCw, { size: 18 }) }), (0, jsx_runtime_1.jsxs)("div", { className: "update-banner-text", children: [(0, jsx_runtime_1.jsxs)("span", { className: "font-bold", children: ["Yeni s\u00FCr\u00FCm mevcut! (v", latestVersion, ")"] }), (0, jsx_runtime_1.jsx)("span", { className: "update-banner-desc hidden sm:inline", children: " Yeni \u00F6zellikleri ke\u015Ffetmek ve daha iyi bir deneyim i\u00E7in g\u00FCncelleyin." })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "update-banner-actions", children: [(0, jsx_runtime_1.jsxs)("button", { className: "btn btn-primary btn-sm", onClick: handleDownload, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Download, { size: 14, className: "mr-1" }), " \u0130ndir"] }), (0, jsx_runtime_1.jsx)("button", { className: "update-banner-close", onClick: () => setShowBanner(false), children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 16 }) })] })] })) }));
};
exports.UpdateManager = UpdateManager;
